module.exports = __webpack_public_path__ + "img/technology-4.e27d0bcb.png";